import src from "IMAGE";
export default { src, width: 638, height: 203, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARklEQVR42i3MsQ1AUBRA0debQKOgtQERiUZpCQq1SnTEGlZ1fvKL093ciIiel52BjpqNhqi4WXhoOZgoUrByMfNR5uPI+QNlwQfVWvJFbAAAAABJRU5ErkJggg=="};
